import MarketingImage from '@/components/landing/MarketingImage';
import React from 'react';
import Button from '@mui/material/Button';
import { Link as RouterLink } from 'react-router-dom';
const gdprReady = '/images/marketing/landing-gdpr-badges-gdpr-ready.webp';
const ukEuGdprPrivacyReady = '/images/marketing/landing-gdpr-badges-uk-eu-gdpr-privacy-ready.webp';
const gdprCompliant = '/images/marketing/landing-gdpr-badges-gdpr-compliant.webp';
const HeroSectionImage = '/images/marketing/hero-section.webp';
import { scrollToLandingLeadForm } from '@/utils/landingLeadIntent';
import styles from './HeroSection.module.css';

type HeroSectionProps = {
  /** Paid-traffic /start page: single Start Free CTA and scale headline. */
  variant?: 'default' | 'start';
};

// LANDING PAGE COMPONENT: HeroSection
// This component can be easily separated for launching the landing page first
const HeroSection = ({ variant = 'default' }: HeroSectionProps) => {
  const isStart = variant === 'start';

  return (
    <section
      id={isStart ? 'start-hero' : undefined}
      className={`${styles.heroSection} ${isStart ? styles.startHero : ''}`}
    >
      <div className={styles.heroCanvas}>
        <div className={`${styles.heroContent} ${isStart ? styles.startContent : ''}`}>
          <div className={styles.leftPane}>
            <div className={`${styles.complianceRow} animate-fade-in`}>
              <MarketingImage loading="eager" src={gdprReady} alt="GDPR ready" width={712} height={278} />
              <MarketingImage loading="eager" src={ukEuGdprPrivacyReady} alt="UK and EU GDPR privacy ready" width={1084} height={278} />
              <MarketingImage loading="eager" src={gdprCompliant} alt="GDPR compliant" width={686} height={278} />
            </div>

            {isStart ? (
              <h1 className={`${styles.heroTitle} animate-fade-in`}>
                <span className={styles.heroTitleLine}>
                  Scale your nutrition practice <span className={styles.gradientText}>3X</span>.{' '}
                  <span className={styles.heroTitleAccent}>Without scaling your workload.</span>
                </span>
              </h1>
            ) : (
              <>
                <h1 className={`${styles.heroTitle} animate-fade-in`}>
                  <span className={styles.heroTitleLine}>
                    The intelligence layer powering the future of{' '}
                    <span className={styles.heroTitleAccent}>personalized nutrition.</span>
                  </span>
                </h1>

                <p className={`${styles.heroLead} animate-fade-in`} style={{ animationDelay: '0.1s' }}>
                  Scale your nutrition practice <span className={styles.gradientText}>3X</span> — without scaling your workload.
                </p>
              </>
            )}

            {/* <p
              className={`${styles.heroDescription} animate-fade-in`}
              style={{ animationDelay: '0.2s' }}
            >
              CalorieScience helps practitioners transform complex client data, biomarkers, and nutrition science into personalized care — reducing admin, improving efficiency, and enabling practice growth.
            </p> */}

            <div
              className={`${styles.actionRow} animate-fade-in`}
              style={{ animationDelay: '0.3s' }}
            >
              {/* <Button
                component="a"
                href="#ready-to-grow-practice"
                className={styles.exploreButton}
                data-analytics-event="Landing CTA Clicked"
                data-analytics-id="hero_join_beta"
                data-analytics-label="Join our Beta Program"
                data-analytics-section="hero"
              >
                Join our Beta Program
              </Button> */}
              <Button
                component={RouterLink}
                to="/signup"
                variant="outlined"
                className={styles.getStartedButton}
                data-analytics-event="Landing CTA Clicked"
                data-analytics-id={isStart ? 'start_hero_get_started' : 'hero_get_started'}
                data-analytics-label={isStart ? 'Start Free' : 'Start for Free'}
                data-analytics-section="hero"
              >
                {isStart ? 'Start Free' : 'Start for Free'}
              </Button>
              {!isStart && (
                <Button
                  type="button"
                  variant="outlined"
                  className={styles.bookDemoButton}
                  onClick={() => scrollToLandingLeadForm('book_demo')}
                  data-analytics-event="Landing CTA Clicked"
                  data-analytics-id="hero_book_demo"
                  data-analytics-label="Book a Demo"
                  data-analytics-section="hero"
                >
                  Book a Demo
                </Button>
              )}
            </div>
            {isStart && (
              <p className={`${styles.trialNote} animate-fade-in`} style={{ animationDelay: '0.35s' }}>
                31 days free. No credit card.
              </p>
            )}

          </div>

          <div className={styles.rightPane}>
            <MarketingImage loading="eager"
              fetchPriority="high"
              src={HeroSectionImage}
              alt="CalorieScience platform preview"
              className={styles.heroImage}
            />
          </div>
        </div>
      </div>

      {/* <div className={styles.professionStrip}> */}
        {/* <div className={styles.professionTrack}>
          <span>Clinical Nutritionists</span>
          <span className={styles.dot}>◉</span>
          <span>Dietitians</span>
          <span className={styles.dot}>◉</span>
          <span>Fitness and Health Coaches</span>
          <span className={styles.dot}>◉</span>
          <span>Mental Health Professionals</span>
          <span className={styles.dot}>◉</span>
          <span>Clinical Nutritionists</span>
          <span className={styles.dot}>◉</span>
          <span>Dietitians</span>
          <span className={styles.dot}>◉</span>
          <span>Fitness and Health Coaches</span>
          <span className={styles.dot}>◉</span>
          <span>Mental Health Professionals</span>
        </div> */}
      {/* </div> */}
    </section>
  );
};

export default HeroSection;
